/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { observer } from 'mobx-react';
import { Row, Col, Container } from 'reactstrap';
import Subject from './subject';

export default observer(({ match, inactive, subjects }) => {
    const isInactive = inactive === 'true';
    if (!subjects) {
        return (
            <div>
                <Container>
                    <Row>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                        <Col md="6" xs="12">
                            <div className="loading-group" />
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    } else if (subjects) {
        // Display each group

        return (
            <div className={'videos' + (isInactive ? ' inactive' : ' ')}>
                {
                    <div className="d-flex flex-column">
                        {subjects.map((subject) => {
                            return (
                                <Subject
                                    match={match}
                                    subject={subject}
                                    key={subject.id}
                                />
                            );
                        })}
                    </div>
                }
            </div>
        );
    } else {
        return null;
    }
});
